const state = () => ({
    user:{ 
        name: null,
        token : null,
    },
});
export default state;
